import { PromotionPayload } from 'api/promotion'
import HeaderCell from 'components/HeaderCell'
import Pagination from 'components/Pagination'
import { buildTranslate } from 'locales'
import { Fields as MerchantFields } from 'models/Merchant'
import React, { useEffect, useState } from 'react'
import '../PromoCodes.scss'
import PromotionRow from './PromotionRow'

const t = buildTranslate('promo_codes.landing.table')
const tChannel = buildTranslate('promo_codes.channel_status')

type PromotionsTableProps = {
  promotions: PromotionPayload[]
  isMobile: boolean
  tab: 'active' | 'draft' | 'complete'
  // Channel-acceptance columns (LOY-622). Gated by the caller; when
  // `showChannels` is false the two columns are omitted entirely.
  showChannels?: boolean
  merchant?: MerchantFields | null
  toastInstoreEnabled?: boolean
  onConfigureOnline?: () => void
}

const PAGE_SIZE = 10

const PromotionsTable: React.FC<PromotionsTableProps> = ({
  promotions,
  isMobile,
  tab,
  showChannels = false,
  merchant,
  toastInstoreEnabled = false,
  onConfigureOnline,
}) => {
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    setCurrentPage(1)
  }, [tab])

  const numberOfPages = Math.ceil(promotions.length / PAGE_SIZE)
  const clampedPage = Math.min(currentPage, numberOfPages || 1)
  const paginatedPromotions = promotions.slice(
    (clampedPage - 1) * PAGE_SIZE,
    clampedPage * PAGE_SIZE
  )

  const tableElement = (
    <table className="full-width campaign-table">
      <thead>
        <tr>
          <HeaderCell>{t('name')}</HeaderCell>
          <HeaderCell>{t('promo_code')}</HeaderCell>
          <HeaderCell>{t('redemptions')}</HeaderCell>
          <HeaderCell>{t('expiration')}</HeaderCell>
          {showChannels && (
            <>
              <HeaderCell>{tChannel('online_header')}</HeaderCell>
              <HeaderCell>{tChannel('pos_header')}</HeaderCell>
            </>
          )}
          <HeaderCell className="promo-col-view" />
          <HeaderCell className="promo-col-actions" />
        </tr>
      </thead>
      <tbody data-testid="promotions-table-body">
        {paginatedPromotions.map(promotion => (
          <PromotionRow
            promotion={promotion}
            tab={tab}
            key={promotion.id}
            showChannels={showChannels}
            merchant={merchant}
            toastInstoreEnabled={toastInstoreEnabled}
            onConfigureOnline={onConfigureOnline}
          />
        ))}
      </tbody>
    </table>
  )

  return (
    <>
      {isMobile ? (
        <div className="table-responsive">{tableElement}</div>
      ) : (
        tableElement
      )}
      {numberOfPages > 1 && (
        <div className="d-flex justify-content-center margin-top-huge">
          <Pagination
            currentPage={clampedPage}
            onChangePage={setCurrentPage}
            numPages={numberOfPages}
          />
        </div>
      )}
    </>
  )
}

export default PromotionsTable
